<template>
  <div
    v-if="labelList.length > 1"
    class="plv-iar-product-label-list"
    v-click-out-side="closePopper"
  >
    <div class="plv-iar-product-label-list__inner">
      <div
        ref="scrollElem"
        class="plv-iar-product-label-list__scroll"
      >
        <div
          v-for="(item, index) in labelList"
          :key="index"
          class="plv-iar-product-label-list__item"
          :class="{
            'plv-iar-product-label-list__item--active': item.id === value,
          }"
          :title="item.name"
          @click="onClickItem(item)"
        >{{ item.name }}</div>
      </div>
      <div v-if="leftArrowVisible" class="plv-iar-product-label-list__shadow--left"></div>
      <div v-if="rightArrowVisible" class="plv-iar-product-label-list__shadow--right"></div>
    </div>

    <div
      class="plv-iar-product-label-list__arrow"
      :class="{
        'plv-iar-product-label-list__arrow--active': popperVisible
      }"
      @click="popperVisible = !popperVisible"
    >
      <icon-arrow-down class="plv-iar-product-label-list__arrow__icon" />
    </div>

    <div v-show="popperVisible" class="plv-iar-product-label-list__popper">
      <div class="plv-iar-product-label-list__popper__content" @scroll="onScroll($event, 'vertical')">
        <div
          v-for="(item, index) in labelList"
          :key="`popper-${index}`"
          class="plv-iar-product-label-list__popper__item"
          :class="{
            'plv-iar-product-label-list__popper__item--active': item.id === value,
          }"
          :title="item.name"
          @click="onClickItem(item)"
        >
          <div class="plv-iar-product-label-list__popper__item__btn">{{ item.name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconArrowDown from '@/icon-components/icons/icon-arrow-down';
import mixin from './mixin';
import ClickOutSide from '@/assets/utils/click-out-side';

export default {
  components: {
    IconArrowDown,
  },
  mixins: [mixin],
  directives: { ClickOutSide },
};
</script>

<style lang="scss">
@import '../../../../assets/styles/basic.scss';
.plv-iar-product-label-list {
  display: flex;
  position: relative;
}
.plv-iar-product-label-list__inner {
  flex: 1;
  overflow: hidden;
  position: relative;
}
.plv-iar-product-label-list__scroll {
  padding-bottom: 16px;
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-wrap: nowrap;
  white-space: nowrap;
}
.plv-iar-product-label-list__item {
  height: 32px;
  line-height: 30px;
  border-radius: 18px;
  padding: 0 8px;
  font-size: 12px;
  color: #fff;
  background-color: rgba(#fff, 0.1);
  margin-right: 8px;
  box-sizing: border-box;
  cursor: pointer;
  border: 1px solid transparent;

  &.plv-iar-product-label-list__item--active {
    color: #F15D5D;
    border: 1px solid #482c31;
  }

  &:last-of-type {
    margin-right: 0;
  }
}

.plv-iar-product-label-list__shadow--left,
.plv-iar-product-label-list__shadow--right {
  position: absolute;
  top: 0;
  width: 32px;
  height: 100%;
  pointer-events: none;
}
.plv-iar-product-label-list__shadow--left {
  left: 0;
  background: linear-gradient(90deg, rgba(#1a1a1f, 1) 0, rgba(#1a1a1f, 0) 100%);
}
.plv-iar-product-label-list__shadow--right {
  right: 0;
  background: linear-gradient(90deg, rgba(#1a1a1f, 0) 0, rgba(#1a1a1f, 1) 100%);
}

.plv-iar-product-label-list__arrow {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: -10px;
  cursor: pointer;
}
.plv-iar-product-label-list__arrow__icon {
  color: #fff;
  font-size: 16px;
  display: flex;
  transition: 0.3s;
}
.plv-iar-product-label-list__arrow--active {
  .plv-iar-product-label-list__arrow__icon {
    transform: rotateZ(180deg);
  }
}

.plv-iar-product-label-list__popper {
  position: absolute;
  left: -8px;
  right: -8px;
  top: 90%;

  &::before {
    content: '';
    height: 0;
    border-style: solid;
    border-width: 6px;
    border-color: transparent transparent #fff transparent;
    position: absolute;
    top: -12px;
    right: 8px;
  }
}
.plv-iar-product-label-list__popper__content {
  background: #fff;
  border-radius: 8px;
  padding: 16px 8px 8px;
  display: flex;
  flex-wrap: wrap;
  max-height: 182px;
  overflow-y: auto;
  box-sizing: border-box;
}
.plv-iar-product-label-list__popper__item {
  width: 33.3%;
  flex-shrink: 0;
  padding: 0 4px 8px;
  box-sizing: border-box;
}
.plv-iar-product-label-list__popper__item__btn {
  text-align: center;
  height: 30px;
  padding: 0 6px;
  box-sizing: border-box;
  line-height: 28px;
  border-radius: 15px;
  font-size: 12px;
  background: rgba(0, 0, 0, 0.04);
  color: #333;
  border: 1px solid transparent;
  cursor: pointer;
  @include text-singleline;
}
.plv-iar-product-label-list__popper__item--active {
  .plv-iar-product-label-list__popper__item__btn {
    border-color: #F15D5D;
    color: #F15D5D;
  }
}
</style>
